/** 线路排班-观察模式 */
<template>
  <div id="commission">
    <el-tabs type="card" v-model="tabAction">
      <el-tab-pane name="commissionSpecialLine" class="grid">
        <template slot="label"><i class="el-icon-s-finance" style="margin-right:4px"></i>专线订单提成</template>
        <commissionSpecialLine />
      </el-tab-pane>
      <el-tab-pane name="commissionCharteredBus" class="grid">
        <template slot="label"><i class="el-icon-truck" style="margin-right:4px"></i>专线包车订单提成</template>
        <commissionCharteredBus />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "commission",
  components: {
    commissionSpecialLine: () => import("./commissionSpecialLine.vue"),
    commissionCharteredBus: () => import("./commissionCharteredBus.vue"),
  },
  data() {
    return {
      tabAction: 'commissionSpecialLine',
    }
  },
};
</script>

